import './Title.css';
import React from 'react'

const Title = ({title , text}) => {
  return (
    <div>
      <div className="title mb-3">
      <div className="title-head d-flex align-items-center gap-1 mb-1">
        <p className="m-0"></p>
        <h2 className="mb-0">{title}</h2>
      </div>
      <div className='txtt d-none d-lg-block'>{text}</div>
    </div>
    </div>
  )
}

export default Title